<template>
    <modal :title="setModel>0?'Update Branch User':'Add Branch User'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem" ref="form">
                <formGroup :title="'Name'" v-model="model.Name" :errors="errors" :rules="{required:true,max:100}" @keydown.enter="save"></formGroup>
                <formGroup :title="'Email'" v-model="model.Email" :errors="errors" :rules="{required:true,max:100,email:true}" @keydown.enter="save"></formGroup>
                <formGroup :title="'Password'" type="password" v-model="model.Password" :errors="errors" :rules="{required:true,max:50}" @keydown.enter="save"></formGroup>
                <formGroup :title="'Phone'" v-model="model.Phone" :errors="errors" :rules="{min:10}" @keydown.enter="save"></formGroup>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :disabled="process" :process="process">{{setModel>0?'Update Branch User':'Add Branch User'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            BranchId:Number
        },
        data(){
            return{
                addSoftwareOpen:false,
                model:{
                    BranchId:this.BranchId,
                    Name:null,
                    Email:null,
                    Password:null,
                    Phone:null,
                    IsCustomerAdmin:false
                },
                process:false
            }
        },
        created(){
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.post(`Users/Branchs/Add`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:"The branch user has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            this.$emit("add",response.data);
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>